var _Box;
import React from 'react';
import { Box } from '@lumahealthhq/ui-core';

/**
 * This is the Fallback component to render till the module is ready.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export default function FallbackContainerTableBroadcasts() {
  return _Box || (_Box = /*#__PURE__*/_jsx(Box, {}));
}